import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3df8e0a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Show List of My Tasks which are either completed or active", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Show all Tasks currently in the system assigned to all the User Employees.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Create Task from Template associate with a job and Assign User to task.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Create Task from Template for personal tasks which wont be associated to any job.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Create the Task template for the Task we are going to create which will add some predefined properties to task", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Show All Jobs currently present in the system with start date and end date.", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Create Job from Template and Create tasks Associated with that job.", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Create the Job template for the job we are going to create which will add some predefined properties to job", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Show list of all Users which are in the System with Basic Information from where we can see the full profile of the user, delete user or can generate pdf Report of user.", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Create User or User Employee who will be able to use system.", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Make Changes in the Hourly Pay, Work Center and Status of the employee which is present in the system. ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Add the WorkCenter and CostCenter which we are going to add to various fileds", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "See WorkCenters and CostCenters in the system.", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Get Visual representation of progress Jobs and Tasks with the help of Gantt Chart", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Scheduling and Reminders of Tasks and jobs with help of Calendar", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Get Total Active Hours spent On Tasks and Jobs and also get Costing of all Jobs and Tasks", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Manage and create new job and task templates.", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/admin/",
  target: "_blank"
}, [
  /*#__PURE__*/_createTextVNode("Admin "),
  /*#__PURE__*/_createElementVNode("p", null, "Visit the Admin Backend of the Project")
], -1))
const _hoisted_19 = {
  key: 0,
  class: "user-profile-popup"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Show List of My Tasks which are either completed or active", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Show all Tasks currently in the system assigned to all the User Employees.", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Create Task from Template associate with a job and Assign User to task.", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Create Task from Template for personal tasks which wont be associated to any job.", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Create the Task template for the Task we are going to create which will add some predefined properties to task", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Show All Jobs currently present in the system with start date and end date.", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Create Job from Template and Create tasks Associated with that job.", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Create the Job template for the job we are going to create which will add some predefined properties to job", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Show list of all Users which are in the System with Basic Information from where we can see the full profile of the user, delete user or can generate pdf Report of user.", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Manage and create new job and task templates.", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Add the WorkCenter and CostCenter which we are going to add to various fileds", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "See WorkCenters and CostCenters in the system.", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Get Visual representation of progress Jobs and Tasks with the help of Gantt Chart", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Scheduling and Reminders of Tasks and jobs with help of Calendar", -1))
const _hoisted_34 = {
  key: 0,
  class: "user-profile-popup"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Show List of My Tasks which are either completed or active", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Create Task from Template for personal tasks which wont be associated to any job.", -1))
const _hoisted_37 = {
  key: 0,
  class: "user-profile-popup"
}

import { ref, onMounted, onUnmounted } from 'vue';
import { useOpsSupplementStore } from '@/stores/OpsSupplement';
import { useTaskStore } from '@/stores/Tasks';
import { useEmployeeStore } from '@/stores/UserEmployee';
import DropdownMenu from '@/components/DropdownMenu.vue'
import AppProfileCard from '@/components/AppProfileCard.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppNavBar',
  setup(__props) {

const opsSupp = useOpsSupplementStore();
const taskStore = useTaskStore();
const userEmployeeStore = useEmployeeStore();
const showUserProfile = ref(false);

opsSupp.fetch();
taskStore.fetch();
taskStore.getAllTasks();

const dropdowns = ref({
    tasks: false,
    jobs: false,
    utilities: false,
    users: false
});

userEmployeeStore.fetch()
    .catch(() => {
        window.location.href = "/accounts/login/?next=" + window.location.pathname;
    });

const toggleDropdown = (dropdownName, event) => {
    event.stopPropagation();
    dropdowns.value[dropdownName] = !dropdowns.value[dropdownName];
    for (const key in dropdowns.value) {
        if (key !== dropdownName) {
            dropdowns.value[key] = false;
        }
    }
};

const closeAllDropdowns = () => {
    for (const dropdown in dropdowns.value) {
        dropdowns.value[dropdown] = false;
    }
};

const handleOutsideClick = (event) => {
    const dropdownElements = document.querySelectorAll('.dropdown');
    let isClickInsideDropdown = false;

    dropdownElements.forEach((dropdownElement) => {
        if (dropdownElement.contains(event.target)) {
            isClickInsideDropdown = true;
        }
    });
    if (!isClickInsideDropdown) {
        closeAllDropdowns();
    }
};

const toggleUserProfile = (event) => {
    event.stopPropagation();
    showUserProfile.value = !showUserProfile.value;
};

const handleClickOutside = (event) => {
    if (!event.target.closest('.profile-container')) {
        showUserProfile.value = false;
    }
};

onMounted(() => {
    document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withCtx(() => [
        _createTextVNode("MudBots")
      ]),
      _: 1
    }),
    (_unref(userEmployeeStore).currentUser?.user.is_superuser)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(DropdownMenu, { title: "Tasks" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/ops/" }, {
                default: _withCtx(() => [
                  _createTextVNode("My Tasks "),
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/ops/alltasks" }, {
                default: _withCtx(() => [
                  _createTextVNode("All Tasks "),
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/ops/create-task/1" }, {
                default: _withCtx(() => [
                  _createTextVNode("Create Employee Tasks "),
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/ops/create-task-employee/1" }, {
                default: _withCtx(() => [
                  _createTextVNode("Create Personal Task "),
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/ops/create-task-template" }, {
                default: _withCtx(() => [
                  _createTextVNode("Create Task Template "),
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(DropdownMenu, { title: "Jobs" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/ops/alljobs" }, {
                default: _withCtx(() => [
                  _createTextVNode("All Jobs "),
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/ops/create-job/1" }, {
                default: _withCtx(() => [
                  _createTextVNode("Create Job "),
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/ops/create-job-template",
                class: "job-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Create Job Template "),
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(DropdownMenu, { title: "User" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/ops/allusers" }, {
                default: _withCtx(() => [
                  _createTextVNode("User List "),
                  _hoisted_9
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/ops/create-user" }, {
                default: _withCtx(() => [
                  _createTextVNode("Create User "),
                  _hoisted_10
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/ops/Adduseremployee" }, {
                default: _withCtx(() => [
                  _createTextVNode("Employee Salaries "),
                  _hoisted_11
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(DropdownMenu, { title: "Utilities" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/ops/work-cost-center" }, {
                default: _withCtx(() => [
                  _createTextVNode("Add Work & Cost Center "),
                  _hoisted_12
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/ops/work-and-cost-center" }, {
                default: _withCtx(() => [
                  _createTextVNode("Work & Cost Center "),
                  _hoisted_13
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/ops/gantt-chart" }, {
                default: _withCtx(() => [
                  _createTextVNode("Gantt Chart "),
                  _hoisted_14
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/ops/Calender" }, {
                default: _withCtx(() => [
                  _createTextVNode("Calendar "),
                  _hoisted_15
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/ops/admindashboard" }, {
                default: _withCtx(() => [
                  _createTextVNode("Costing "),
                  _hoisted_16
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/ops/job-task-template" }, {
                default: _withCtx(() => [
                  _createTextVNode("Job & Task Templates "),
                  _hoisted_17
                ]),
                _: 1
              }),
              _hoisted_18
            ]),
            _: 1
          }),
          _createElementVNode("a", {
            class: "profile-container",
            href: "/app/ops/user-profile",
            onClick: _withModifiers(toggleUserProfile, ["prevent"])
          }, "Profile"),
          (showUserProfile.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode(AppProfileCard)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_unref(userEmployeeStore).currentUser?.user.is_staff && !_unref(userEmployeeStore).currentUser?.user.is_superuser)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(DropdownMenu, { title: "Tasks" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/ops/" }, {
                default: _withCtx(() => [
                  _createTextVNode("My Tasks "),
                  _hoisted_20
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/ops/alltasks" }, {
                default: _withCtx(() => [
                  _createTextVNode("All Tasks "),
                  _hoisted_21
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/ops/create-task/1" }, {
                default: _withCtx(() => [
                  _createTextVNode("Create Employee Tasks "),
                  _hoisted_22
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/ops/create-task-employee/1" }, {
                default: _withCtx(() => [
                  _createTextVNode("Create Personal Task "),
                  _hoisted_23
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/ops/create-task-template" }, {
                default: _withCtx(() => [
                  _createTextVNode("Create Task Template "),
                  _hoisted_24
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(DropdownMenu, { title: "Jobs" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/ops/alljobs" }, {
                default: _withCtx(() => [
                  _createTextVNode("All Jobs "),
                  _hoisted_25
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/ops/create-job/1" }, {
                default: _withCtx(() => [
                  _createTextVNode("Create Job "),
                  _hoisted_26
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/ops/create-job-template",
                class: "job-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Create Job Template "),
                  _hoisted_27
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(DropdownMenu, { title: "User" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/ops/allusers" }, {
                default: _withCtx(() => [
                  _createTextVNode("User List "),
                  _hoisted_28
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(DropdownMenu, { title: "Utilities" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/ops/job-task-template" }, {
                default: _withCtx(() => [
                  _createTextVNode("Job & Task Templates "),
                  _hoisted_29
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/ops/work-cost-center" }, {
                default: _withCtx(() => [
                  _createTextVNode("Add Work & Cost Center "),
                  _hoisted_30
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/ops/work-and-cost-center" }, {
                default: _withCtx(() => [
                  _createTextVNode("Work & Cost Center "),
                  _hoisted_31
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/ops/gantt-chart" }, {
                default: _withCtx(() => [
                  _createTextVNode("Gantt Chart "),
                  _hoisted_32
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/ops/Calender" }, {
                default: _withCtx(() => [
                  _createTextVNode("Calendar "),
                  _hoisted_33
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("a", {
            class: "profile-container",
            href: "/app/ops/user-profile",
            onClick: _withModifiers(toggleUserProfile, ["prevent"])
          }, "Profile"),
          (showUserProfile.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createVNode(AppProfileCard)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (!_unref(userEmployeeStore).currentUser?.user.is_superuser && !_unref(userEmployeeStore).currentUser?.user.is_staff)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createVNode(DropdownMenu, { title: "Tasks" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/ops/" }, {
                default: _withCtx(() => [
                  _createTextVNode("My Tasks "),
                  _hoisted_35
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/ops/create-task-employee/1" }, {
                default: _withCtx(() => [
                  _createTextVNode("Create Task "),
                  _hoisted_36
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/ops/Calender" }, {
            default: _withCtx(() => [
              _createTextVNode("Calendar")
            ]),
            _: 1
          }),
          _createElementVNode("a", {
            class: "profile-container",
            href: "/app/ops/user-profile",
            onClick: _withModifiers(toggleUserProfile, ["prevent"])
          }, "Profile"),
          (showUserProfile.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createVNode(AppProfileCard)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})